import { Navigate, useLocation } from "react-router-dom";
import { message } from "antd";
import { useUser } from "../context/UserContext";
import { getPostLoginPath } from "../utils/roleUtils";

const ProtectedRoute = ({ children, requiredRole, forbiddenRole }) => {
  const location = useLocation();
  const { userData, loading } = useUser();

  const userRoles = Array.isArray(userData?.roles) ? userData.roles : [];

  // While user data is loading on first visit, don't decide yet (prevents false denials)
  if (loading && !userData?.id) {
    console.log("ProtectedRoute - Loading user data, delaying access check");
    return null;
  }

  // Debug logging
  console.log("ProtectedRoute - Required role:", requiredRole);
  console.log("ProtectedRoute - Forbidden role:", forbiddenRole);
  console.log("ProtectedRoute - User roles:", userRoles);

  const hasRoleInList = (role) =>
    userRoles.some((r) => r && r.toLowerCase() === role.toLowerCase());

  // Check for required role
  if (requiredRole) {
    if (!hasRoleInList(requiredRole)) {
      console.log("ProtectedRoute - Access denied: User doesn't have required role");
      message.error("Access denied: You don't have permission to access this page");
      return <Navigate to="/" state={{ from: location }} replace />;
    }
  }

  // Check for forbidden role
  if (forbiddenRole) {
    if (hasRoleInList(forbiddenRole)) {
      console.log("ProtectedRoute - Access denied: User has forbidden role");
      message.error("Access denied: This page is not available for your role");
      // Redirect forbidden role to appropriate page
      if (forbiddenRole.toLowerCase() === "admin") {
        return <Navigate to="/admin" replace />;
      } else {
        return <Navigate to={getPostLoginPath(userRoles)} replace />;
      }
    }
  }

  return children;
};

export default ProtectedRoute;
